<capra-icon-button
  class="dropper-button"
  icon="icon-dropper"
  data-test="color-picker-color-dropper"
  [attr.aria-label]="
    isSupported
      ? 'Pick a color from anywhere on the screen'
      : 'Your browser does not support the color dropper'
  "
  capraTooltip
  tooltipPlacement="bottom"
  [tooltipContent]="
    isSupported ? 'Pick color from screen' : 'Your browser does not support the color dropper'
  "
  [disabled]="!isSupported"
  (clicked)="openDropper()"
></capra-icon-button>
